import React from "react";

const RaceInfo = ({ trackInfo, raceInfo }) => {
  if (raceInfo) {
    return (
      <>
        <div
          className="containerInformation"
          style={{
            backgroundImage: "url('./images/headerRaceInfo.jpg')",
            backgroundRepeat: "no-repeat, repeat",
            backgroundSize: "100% 100%",
            borderRadius: "5px 5px 0px 0px",
            marginBottom: "0px",
          }}
        >
          <div style={{ backgroundColor: "rgba(0, 85, 128, 0.7)" }}>
            <div className="col-sm-12">
              <div className="" style={{ display: "inline-block" }}>
                <label
                  className="mt-1 ml-1"
                  style={{
                    fontFamily: "fantasy",
                    color: "#ffffff",
                    fontSize: "25px",
                    margin: "0px",
                  }}
                >
                  <span
                    className="mr-2"
                    style={{ color: "#1cc8e3", textDecoration: "underline" }}
                  >
                    {trackInfo.TrackCode}
                  </span>{" "}
                  {trackInfo.TrackName}
                </label>
              </div>
              <div
                className=""
                style={{ display: "inline-block", float: "right" }}
              >
                <div>
                  <label
                    className="ml-5 hoverFont mt-1"
                    style={{
                      fontSize: "16px",
                      textAlign: "right",
                      textDecoration: "none",
                    }}
                    href="#!"
                    data-toggle="collapse"
                    data-target="#collapseWeather"
                    aria-expanded="false"
                  >
                    Weather Conditions
                  </label>
                </div>
              </div>
            </div>
            <div
              id="collapseWeather"
              className="collapse card-body"
              aria-labelledby="headingDetails"
            >
              <label className="" style={{ color: "#ffffff" }}>
                {raceInfo.TrackCond || ""}
              </label>
              <span>
                {/* <img src="./images/sun.png" alt="" width="20" height="20" /> */}
              </span>
            </div>

            <div className="mt-3 ml-3">
              <div className="row">
                <div className="col-sm-2">
                  <label
                    className="ml-1"
                    style={{
                      fontFamily: "fantasy",
                      color: "#ffffff",
                      fontSize: "25px",
                      margin: "0px",
                    }}
                  >
                    RACE # {raceInfo.RaceNumber}
                  </label>
                </div>
                <div className="row col-sm-8 mt-1">
                  <div
                    className="col-sm-3"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <label
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                      }}
                    >
                      Class
                    </label>
                  </div>
                  <div
                    className="col-sm-3"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <label
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                      }}
                    >
                      Purse
                    </label>
                  </div>
                  <div
                    className="col-sm-3"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <label
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                      }}
                    >
                      Distance
                    </label>
                  </div>
                  <div
                    className="col-sm-3"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <label
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                      }}
                    >
                      Surface
                    </label>
                  </div>
                </div>
                <div className="col">
                  <div
                    className="mt-1 mr-3"
                    style={{ display: "inline-block", float: "right" }}
                  >
                    <div>
                      <label
                        className="hoverFont"
                        style={{
                          fontSize: "16px",
                          textDecoration: "none",
                        }}
                        href="#!"
                        data-toggle="collapse"
                        data-target="#collapseDetails"
                        aria-expanded="false"
                      >
                        MORE
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-2"></div>
                <div className="row col-sm-8 mt-1 mb-1">
                  <div
                    className="col-sm-3"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <label
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                      }}
                    >
                      {raceInfo.Class}
                    </label>
                  </div>
                  <div
                    className="col-sm-3"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <label
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                      }}
                    >
                      $ {raceInfo.Purse}
                    </label>
                  </div>
                  <div
                    className="col-sm-3"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <label
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                      }}
                    >
                      {raceInfo.Distance}
                    </label>
                  </div>
                  <div
                    className="col-sm-3"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <label
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                      }}
                    >
                      {raceInfo.Surface}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="collapseDetails"
              className="collapse card-body"
              aria-labelledby="headingDetails"
            >
              <label
                htmlFor="RaceDesc"
                className=""
                style={{ color: "#ffffff" }}
              >
                {raceInfo.RaceDesc}
              </label>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
};

export default RaceInfo;
